export default "__VITE_ASSET__DpT7Xgfe__"